import React from "react";
import * as Yup from "yup";
import moment_tz, { Moment } from "moment-timezone";
import { useParams } from "react-router-dom";
import { Button, Box } from "@mui/material";
import { Field, Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";

import { fundedTraderActions } from "../../../../reducers/fundedTrader";
import { APIFunds } from "../../../../api";
import { FormDatePicker } from "../../../../components/ui";

const onVocationUntilValidationSchema = Yup.object().shape({
  on_vacation_until: Yup.date()
    .typeError("Invalid date")
    .min(moment_tz(), "")
    .nullable()
    .default(null),
});

type THandleChangeOnVacation = (data: { on_vacation_until: null | Moment }) => Promise<void>;

const OnVocationUntilDateSelect = (): React.ReactElement => {
  const params: { id: string } = useParams();
  const id = +params.id;
  const dispatch = useDispatch();
  const { on_vacation_until } = useSelector((state) => state.fundedTrader);
  const handleChangeOnVacation: THandleChangeOnVacation = async (values) => {
    try {
      dispatch(fundedTraderActions.dataFetchRequest());
      const endVocationDate = moment_tz(values.on_vacation_until)
        .tz("America/Chicago")
        .startOf("day")
        .format();
      const response = await APIFunds.updateFundedTraderDataRequest(id, {
        on_vacation_until: values.on_vacation_until ? endVocationDate : null,
      });
      dispatch(fundedTraderActions.dataFetchSuccess(response.data));
    } catch (error) {
      console.error("Error update on vacation date", error);
      dispatch(fundedTraderActions.dataFetchFailed());
    }
  };

  const isOnVacation = moment_tz(on_vacation_until)
    .tz("America/Chicago")
    .isAfter(moment_tz().tz("America/Chicago"));

  return (
    <div>
      <Formik
        enableReinitialize
        validateOnChange
        onSubmit={handleChangeOnVacation}
        initialValues={{ on_vacation_until: isOnVacation ? moment_tz(on_vacation_until) : null }}
        validationSchema={onVocationUntilValidationSchema}
      >
        {({ isValid, dirty }) => (
          <Box component={Form} sx={{ display: "flex" }}>
            <Field
              name="on_vacation_until"
              label="On Vacation Until:"
              component={FormDatePicker}
              minDate={moment_tz().add(1, "days")}
              datePickerProps={{ size: "small" }}
            />
            <Button sx={{ ml: "3px" }} type="submit" disabled={!isValid || !dirty}>
              Save
            </Button>
          </Box>
        )}
      </Formik>
    </div>
  );
};

export default OnVocationUntilDateSelect;
